module.exports = __webpack_public_path__ + "static/p1-c3592ba8cfb2e0662edffdca8057e8c3.svg";